import { render, staticRenderFns } from "./IndicatorsDataOriginTable.vue?vue&type=template&id=8a8e10fc&scoped=true&"
import script from "./IndicatorsDataOriginTable.vue?vue&type=script&lang=js&"
export * from "./IndicatorsDataOriginTable.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsDataOriginTable.vue?vue&type=style&index=0&id=8a8e10fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8e10fc",
  null
  
)

export default component.exports